const __WEBPACK_NAMESPACE_OBJECT__ = window["danielmoncada"]["angular-datetime-picker"];